



















































import { Component, Watch, Vue } from 'vue-property-decorator'
import { hls } from '@/units'
import { lowerCase } from '@/utils'

@Component
export default class cogOther extends Vue {
  // __DATA
  private search: string = ''
  private active: any = null

  // __METHODS
  private edit (data: any): void {
    this.$emit('events', { type: 'edit', data })
  }

  private remove (data: any): void {
    const conf: boolean = confirm('Confirm to Disabled?')
    if (conf) {
      this.$emit('events', { type: 'remove', data })
    }
  }

  private v (id: number): any {
    const convert: any = (db: any) => db.find((x: any) => x.id === id)
    return {
      bu: convert(this.db.businesses),
      ci: convert(this.db.cities)
    }
  }

  private h (val: string): string {
    return hls(val, this.search)
  }
  
  // __COMPUTED
  private get store (): any {
    const search: string = lowerCase(this.search)
    let data: any = this.db[this.paramName]

    if (this.search) {
      data = data.filter((x: any) => lowerCase(x.name).includes(search))
    }

    if (this.active !== null) {
      data = data.keep('isActive', this.active)
    }

    return data
  }

  private get db (): any {
    const db: any = this.$store.getters['APP.COG/all']
    return {
      ...db,
      active: [
        { id: 1, name: this.$t('enabled') },
        { id: 0, name: this.$t('disabled') }
      ]
    }
  }

  private get paramName (): string {
    const { name }: any = this.$route.params
    return name || ''
  }

  private get fr (): any {
    return {
      br: (this.paramName === 'branches'),
      ca: (['cities', 'areas'].indexOf(this.paramName) < 0)
    }
  }

  // __WATCH
  @Watch('$route') watchRoute (): void {
    this.search = ''
  }
}
